module.exports = __webpack_public_path__ + "08c20a4.ttf";